export function initUserProfile() {
    $('#profile-anchor-subscriptions').css("cursor", "pointer");

    $('#profile-anchor-subscriptions').click(function () {
        $('#tab-list-item-subscriptions').click()
    });

    $('a[href="/profile#application"]').click(function (event) {
        event.preventDefault();
        $('#tab-list-item-application').click()
    });

    $('a[href="/profile#account"]').click(function (event) {
        event.preventDefault();
        $('#tab-list-item-account').click()
    });

    $('a[href="/profile#edit-information"]').click(function (event) {
        event.preventDefault();
        $('#modal-profile-edit-information').modal('show');
    });

    $('a[href="/profile#subscriptions"]').click(function (event) {
        event.preventDefault();
        $('#tab-list-item-subscriptions').click()
    });
}

export function copyToClipboard(text) {
    navigator.clipboard.writeText(text);
}

export function buttonCountdown(buttonId, buttonText, seconds) {
    $(document).ready(function () {
        let button = $("#" + buttonId);
        var timer = setInterval(function () {
            button.text(`${buttonText} (${seconds})`);
            if (seconds === 0) {
                clearInterval(timer);
                button[0].click()
            }
            seconds--;
        }, 1000);
    })
}

export function giveOpacityToBody(opacity) {
    if (opacity) {
        $("body").css({ "opacity": "0.5" })
    }
    else {
        $("body").css({ "opacity": "1" })
    }
}